var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5387 9.5512C12.2258 9.02078 12.7074 8.14995 12.7074 7.34245C12.7074 5.55328 11.4679 4.17578 9.8741 4.17578H6.15535C5.76577 4.17578 5.44702 4.53203 5.44702 4.96745V14.4674C5.44702 14.9029 5.76577 15.2591 6.15535 15.2591H10.2495C11.7158 15.2591 13.0545 13.9212 13.0616 12.2745C13.0687 11.0633 12.4595 10.0262 11.5387 9.5512ZM7.57202 6.15495H9.69702C10.2849 6.15495 10.7595 6.68536 10.7595 7.34245C10.7595 7.99953 10.2849 8.52995 9.69702 8.52995H7.57202V6.15495ZM10.0512 13.2799H7.57202V10.9049H10.0512C10.6391 10.9049 11.1137 11.4354 11.1137 12.0924C11.1137 12.7495 10.6391 13.2799 10.0512 13.2799Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.6f7fb137d1b7d590fda7dad61c79f6c2.svg";
export { ForwardRef as ReactComponent };